import { FormattedMessage } from "react-intl";
import { reports } from "./reports";

export const surveyReportNav = {
  label: <FormattedMessage id="SURVEY_REPORT" />,
  path: (tenantName) => `/${tenantName}/reports/surveyReport`,

  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="SURVEY_REPORT" />,
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  tiles: (
    navigate,
    val1 = "Active",
    val2 = "No",
    val3,
    val4,
    val5,
    val6,
    val7,
    val8
  ) => [
    {
      key: 1,
      label: <FormattedMessage id="RECALL_STATUS" />,
      value: val1,
    },
    {
      key: 2,
      label: <FormattedMessage id="VALIDDATE_TEXT" />,
      value: val2,
    },
    {
      key: 3,
      label: <FormattedMessage id="PARTICIPATE_PERCENTAGE" />,
      value: val3,
    },
    {
      key: 4,
      label: <FormattedMessage id="MANDATORY_TXT" />,
      value: val4,
    },
    {
      key: 5,
      label: <FormattedMessage id="DISTRIBUTED_USERS" />,
      value: val5,
    },
    {
      key: 6,
      label: <FormattedMessage id="NO_OF_RESPONSE" />,
      value: val6,
    },
    {
      key: 7,
      label: <FormattedMessage id="P_Question" />,
      value: val7,
    },
    {
      key: 8,
      label: <FormattedMessage id="NO_OF_QUALITATIVE" />,
      value: val8,
    },
  ],
};
